/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const GET_USER_LICENSES = 'uiActionTypes/GET_USER_LICENSES';
export const GET_USER_LICENSES_SUCCESS = 'uiActionTypes/GET_USER_LICENSES_SUCCESS';
export const GET_USER_LICENSES_FAILURE = 'uiActionTypes/GET_USER_LICENSES_FAILURE';

export const GET_USER_HAS_PERMISSION = 'uiActionTypes/GET_USER_HAS_PERMISSION';
export const GET_USER_HAS_PERMISSION_SUCCESS = 'uiActionTypes/GET_USER_HAS_PERMISSION_SUCCESS';
export const GET_USER_HAS_PERMISSION_FAILURE = 'uiActionTypes/GET_USER_HAS_PERMISSION_FAILURE';

export interface GetUserLicenses {
  type: typeof GET_USER_LICENSES;
  payload?:any,
}

export interface GetUserLicensesSuccess {
  type: typeof GET_USER_LICENSES_SUCCESS;
  payload?:any;
}

export interface GetUserLicensesFailure {
  type: typeof GET_USER_LICENSES_FAILURE;
  payload?:any;
}